import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../utils/cn';

import style from './Checkbox.module.css';

const Checkbox = ({
  className, name, value, onChange, label, checkedColor,
}) => (
  <label htmlFor={name} className={cn([className, style.checkbox, style[checkedColor]])}>
    <input id={name} name={name} type="checkbox" onChange={onChange} checked={value} className={style.input} />
    <span className={style.label}>{label}</span>
  </label>
);

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  checkedColor: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'error', 'warning', 'grey']),
  className: PropTypes.string,
};

Checkbox.defaultProps = {
  label: null,
  checkedColor: 'success',
  className: null,
};

export default Checkbox;
